const BODY = "'Manrope', sans-serif"

type FilmMetaAboveTitleProps = {
    countries?: string
    duration?: string
    premiere?: string | null
    className?: string
}

export default function FilmMetaAboveTitle({ countries, duration, premiere, className = "mb-2" }: FilmMetaAboveTitleProps) {
    const premiereLabel = premiere ? `премьера ${premiere}` : null
    const line = [countries, duration, premiereLabel].filter(Boolean).join(" · ")

    if (!line) return null

    return (
        <p
            className={`text-[13px] leading-snug ${className}`.trim()}
            style={{ fontFamily: BODY, fontWeight: 500, color: "rgba(255,255,255,0.35)" }}>
            {line}
        </p>
    )
}
